import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { register as registerSW } from './utils/serviceWorker'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Register service worker for caching and offline functionality
if (import.meta.env.PROD) {
  registerSW({
    onSuccess: () => {
      console.log('Service worker registered successfully');
    },
    onUpdate: (registration) => {
      // Show update notification
      const updateAvailable = confirm(
        'A new version is available! Click OK to update now, or Cancel to update on next visit.'
      );
      if (updateAvailable && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    },
  });
}